import React from "react";
import * as Yup from "yup";
import Modal from "react-modal";
import InputField from "../../components/inputFields/InputField";
import FormikDropdown from "../../components/inputFields/FormikDropDown";
import { Form, Formik } from "formik";
import Button from "../../components/buttons/Button";
import { toast } from "react-toastify";
import { updateMedicineQuantity } from "../../services/clinic/medicine";
import StyledHeadingText from "../../components/Fonts/StyledHeadingText";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "95%", // Responsive for mobile
    zIndex: 1050,
    padding: "20px",
  },
  overlay: {
    zIndex: 1040,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};

Modal.setAppElement("#root");

const OpenMedicineQuantityAlert = ({ isOpen, onRequestClose, onSave, contentLabel, providedValues }) => {

  const handleFormSubmit = async (values, { setSubmitting }) => {
    try {
      const formData = new FormData();
      formData.append("medicine", providedValues.id);
      formData.append("purchase_date", values.purchase_date);
      formData.append("quantity_purchased", values.quantity_purchased);
      formData.append("purchase_price", values.purchase_price);
      const response = await updateMedicineQuantity(formData);

      if (response?.status === 201) {
        toast.success("Medicine updated successfully!");
        onSave();
        onRequestClose();
      } else {
        let errors = "Opps! Something went wrong, please try again.";
        toast.error(errors);
      }
    } catch (error) {
      let errors =
        error?.response?.data?.error ||
        "Opps! Something went wrong, please try again.";
      toast.error(errors);
    }
    setSubmitting(false);
  };

  const handleDiscardChanges = (resetForm) => {
    resetForm();
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel={contentLabel}
    >
      <div className="max-w-2xl">
        <StyledHeadingText text={"Add Quantity"} />
        <Formik
          initialValues={{
            purchase_date: "",
            quantity_purchased: "",
            purchase_price: "",
          }}
          validationSchema={Yup.object({
            purchase_date: Yup.string().required("Please select date"),
            quantity_purchased: Yup.number().required("Please enter an amount"),
            purchase_price: Yup.string().required("Provide purchase price"),
          })}
          onSubmit={handleFormSubmit}
        >
          {({ isSubmitting, resetForm, values }) => (
            <Form>
              <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100">
                <div className="grid gap-6 md:grid-cols-3">
                  <InputField
                    label="Purchase Date"
                    name="purchase_date"
                    type="date"
                    placeholder="Date"
                    required={true}
                  />
                  <InputField
                    label="Quantity Purchased"
                    name="quantity_purchased"
                    type="text"
                    placeholder="130"
                    required={true}
                  />
                  <InputField
                    label="Purchase Amount"
                    name="purchase_price"
                    type="text"
                    placeholder="1200"
                    required={true}
                  />
                </div>
                <div className="py-5 flex justify-end gap-6">
                  <div>
                    <Button
                      type="button"
                      className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                      onClick={() => handleDiscardChanges(resetForm)}
                      disabled={isSubmitting}
                    >
                      Discard Changes
                    </Button>
                  </div>
                  <div>
                    <Button
                      type="submit"
                      className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save"}
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default OpenMedicineQuantityAlert;
